<!-- POSIZIONARE ALL'INTERNO DI UN DIV RELATIVE CON ALTEZZA FISSA-->
<template>
  <div id="container">
    <div class="row">
      <div class="col-12">
        <h3>DATI CLIENTE</h3>
        <input
          placeholder="nominativo"
          v-model="orderDettails.customerData.nominativo"
          id="nominativo"
          type="text"
        >
        <input
          placeholder="telefono"
          v-model="orderDettails.customerData.telefono"
          id="telefono"
          type="text"
        >
        <input
          placeholder="email"
          v-model="orderDettails.customerData.email"
          id="email"
          type="text"
        >
      </div>
      <div class="col-12">
        <h3>DETTAGLI DISP.</h3>
        <input placeholder="Note" @change="setDeviceDettails('note',$event.target.value)" :value="deviceDettails.note" type="text">
        <input placeholder="Sblocco"  :value="deviceDettails.sblocco" type="text">
        <input placeholder="Data" :value="deviceDettails.data" type="text">
        <input placeholder="Scadenza"  type="text">
        <button>SALVA</button>
      </div>
    </div>
    <div class="row">
      <div class="col-12">Selected Device:{{selectedDevice}}</div>
    </div>
    <div class="row">
      <div class="col-12">
        <h3>DISP. IN RIP.</h3>
        <ul>
          <li
            @click="setSelectedDevice(device,index)"
            :key="device.id"
            v-for="(device,index) in deviceList"
          >
            {{index}}{{device}}
            <b @click="removeDevice(index)">X</b>
          </li>
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <h3>CARRELLO</h3>
        <ul>
          <li v-for="(item,index) in cart" :key="item.id">
            {{item.dispositivo}}
            <select @change="setRepairState(index,$event.target.value)">
              <option value="annullato">annullato</option>
              <option value="sospeso">Sospeso</option>
              <option value="pronto">Pronto</option>
            </select>
            <b @click="removeDevice(index)">X</b>
            <ul v-if="item.ricambi" style="color:green">
              <li v-for="(ricambio,index) in item.ricambi" :key="ricambio.id">
                {{ricambio.value}}
                <b @click="removeFromCart(index)">X</b>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="col-6">
        <selettore
          v-on:itemClicked="itemClicked($event)"
          id="selettore"
          v-bind:selettore="selettore"
        ></selettore>
      </div>
    </div>
    <div class="row">
      <button @click="saveOrder()">SALVA</button>
      <button>AGGIORNA</button>
    </div>
  </div>
</template>

<script>
import { db } from "@/components/Firebase_Conn";
import { ref } from "@/components/puntatori";
import Vue from "vue";
import { jStore } from "../store/jestionaleStore.js";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { mapState, mapGetters } from "vuex";

export default {
  components: {
    VuePerfectScrollbar
  },
  computed: {
    ...mapGetters({
      customerData: "ordineStates/customerData",
      selectedDevice: "ordineStates/selectedDevice",
      cart: "ordineStates/cart",
      deviceList: "ordineStates/deviceList",
      deviceDettails: "ordineStates/deviceDettails",
    })
  },
  name: "OrdineScheletro",
  directives: {},
  filters: {},
  data() {
    return {
      //costuttore del selettore
      deviceDett:{},
      orderDettails : {
        customerData : {},
      },
      selettore: {
        mostra_prezzo: false, //LO USO IN ORDINE
        mostra_sconto: true, // LO USO IN LISTINO
        mantieniAggiuntivo: "", //LASCIA ACCESO IL TASTO AGGIUNTIVO (ES. MENTRE CREO REGOLA LISTINO) E INIBISCE CHE IL TASTO AGGIUNTIVO SI ATTIVI SU ALTRI QUADRATINI
        tastoAggiuntivo: true,
        scrolling_selettore: false,
        fine_scrolling_selettore: false,
        div: "div_selettore",
        wrapper: "wrap_selettore_ricambi",
        css: { height: "92px", marginTop: "8px", marginBottom: "17px" },
        //qui dentro puoi inserire codice puro css per stilizzare il selettore
        style: "",
        scroll: false,
        selezione: 0,
        div_scroll: "PerfectScroll",
        autofocus: false,
        focus: "0",
        termine_ricerca: "",
        timeout: 600,
        delay: "",
        tasto_back: false,
        tasto_nuova_rip: false,
        barra_ricerca: true,
        barra_breadCrumbs: true,
        stato_caricamento: "",
        classe_focus: "sele",
        tasto_aggiungi: false,
        altezza: "",
        step_selezionato: "",
        posizioneSelettore: "",
        arrayCarrello: [],
        positionToChildFolder: ""
      }
    };
  },
  methods: {
    itemClicked(obj) {
      console.log("quadratino cliccato");
      this.$store
        .dispatch("ordineStates/addItemToCart", obj)
        .then(response => {
          console.log("Oggetto inviato al carrello");
        })
        .catch(err => {
          console.log(err);
        });
    },
    setSelectedDevice(obj, value) {
      this.selettore.posizioneSelettore = obj.path;
      this.$store.commit("ordineStates/setSelectedDevice", value);
    },
    setRepairState(index, value) {
      var payload = {
        index: index,
        value: value
      };
      this.$store.commit("ordineStates/setRepairState", payload);
    },
    removeDevice(index) {
      this.$store.commit("ordineStates/removeDevice", index);
    },
    removeFromCart(index) {
      this.$store.commit("ordineStates/removeFromCart", index);
    },
    setDeviceDettails (field,value){
      var payload= {
        field: field,
        value: value
      }
      this.$store.commit("ordineStates/setDeviceDettails", payload)
    },
    saveOrder() {
      this.$store
        .dispatch("ordineStates/saveOrder", {
          /*payload placeholde*/
        })
        .then(response => {
          console.log("Ordine salvato");
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {},
  watch: {
    "orderDettails": {
      handler(){
      console.log('prova')
      var payload = {
        state: "customerData",
        data: this.orderDettails.customerData
      }
      this.$store.commit("ordineStates/setState", payload)
      },
      deep: true
    }
   }
};
</script>

<style scoped>
#ilDiv:focus {
  outline: none;
}
</style>
